/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type RoutePlanUnplannableReasonEnum =
  (typeof RoutePlanUnplannableReasonEnum)[keyof typeof RoutePlanUnplannableReasonEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoutePlanUnplannableReasonEnum = {
  MissingCoordinates: 0,
  NoTimeWindowFit: 1,
  ReservedForManualPlanning: 2,
  ExcludedCaseType: 3,
  PredecessorLegUnplanned: 4,
  FlexibleStock: 5,
  ManualPlanningPlace: 6,
} as const;
